// src/utils/missingKeys.jsx
// In-memory tracker for missing i18n keys.
// DEV: logs each missing key once to the console.
// PROD: quiet (still tracks in memory). No network calls here.

const MAX_KEYS_PER_LANG = 500;        // cap to avoid unbounded growth
const missingKeys = {};               // { [lang]: Set<string> }
const logged = new Set();             // "lang::key" seen in console (DEV)

export function reportMissingKey(lang = "en", key = "") {
  if (!key) return;
  const base = String(lang).split("-")[0] || "en";

  if (!missingKeys[base]) missingKeys[base] = new Set();
  if (missingKeys[base].size < MAX_KEYS_PER_LANG) {
    missingKeys[base].add(key);
  }

  const sig = `${base}::${key}`;
  if (!logged.has(sig) && import.meta?.env?.DEV) {
    // eslint-disable-next-line no-console
    console.warn(`[i18n] Missing key "${key}" in [${base}]`);
    logged.add(sig);
  }
}

export function getMissingKeys(lang) {
  if (lang) return Array.from(missingKeys[lang] || []);
  return Object.fromEntries(
    Object.entries(missingKeys).map(([l, keys]) => [l, Array.from(keys)])
  );
}

export function clearMissingKeys(lang) {
  if (lang) delete missingKeys[lang];
  else Object.keys(missingKeys).forEach((l) => delete missingKeys[l]);
}

export default reportMissingKey;
